import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { connect } from 'react-redux';

import { SharedPagination } from '../../shared/SharedPagination/SharedPagination';
import { ServerVarsContextConsumer } from '../../global/ServerVarsContext/ServerVarsContext';

function BuySharedPaginationComponent({ buyPage, page, uriRef }) {
    const { displayMaxNumberOfPages } = buyPage;
    return (
        <ServerVarsContextConsumer>
            {({ isDesktop, isTablet }) => {
                let totalPageLinks;

                if (isDesktop) {
                    totalPageLinks = 12;
                } else if (isTablet) {
                    totalPageLinks = 8;
                }

                return (
                    <SharedPagination
                        currentPage={page}
                        numberOfPages={displayMaxNumberOfPages}
                        totalPageLinks={totalPageLinks}
                        uriRef={uriRef}
                    />
                );
            }}
        </ServerVarsContextConsumer>
    );
}

BuySharedPaginationComponent.propTypes = {
    buyPage: PropTypes.object.isRequired,
    page: PropTypes.number.isRequired,
    uriRef: PropTypes.string.isRequired,
};

function mapStateToProps({ relayVariables }) {
    const {
        variables: { page, uriRef },
    } = relayVariables;
    return {
        page,
        uriRef,
    };
}

export const BuySharedPagination = createFragmentContainer(
    connect(mapStateToProps)(BuySharedPaginationComponent),
    {
        buyPage: graphql`
            fragment BuySharedPagination_buyPage on ItemSearchQueryConnection {
                displayMaxNumberOfPages
            }
        `,
    }
);
